import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import MobileExperience from "./MobileExperience"; // ✅ Import your mobile experience

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

// Device detection
const isMobile = window.innerWidth < 768;

root.render(
  <React.StrictMode>
    {isMobile ? <MobileExperience /> : <App />}
  </React.StrictMode>
);